var getBrowserName = function getBrowserName(agent) {
  var _a;
  var userAgent = (_a = agent === null || agent === void 0 ? void 0 : agent.toLocaleLowerCase()) !== null && _a !== void 0 ? _a : navigator.userAgent.toLocaleLowerCase();
  if (!userAgent) {
    return 'other';
  }
  switch (true) {
    case userAgent.indexOf('edge') > -1:
      return 'MS Edge';
    case userAgent.indexOf('edg/') > -1:
      return 'Edge (chromium based)';
    case userAgent.indexOf('opr') > -1:
      return 'Opera';
    case userAgent.indexOf('chrome') > -1:
      return 'Chrome';
    case userAgent.indexOf('trident') > -1:
      return 'MS IE';
    case userAgent.indexOf('firefox') > -1:
      return 'Mozilla Firefox';
    case userAgent.indexOf('safari') > -1:
      return 'Safari';
    default:
      return 'other';
  }
};

export { getBrowserName as default };
//# sourceMappingURL=index.js.map
